// extracted by css-extract-rspack-plugin
export default {"sectionHeader":"WgKShi85rOo6CkUk__sectionHeader___","sectionTitle":"eitWv_Z7pyQzSxxs__sectionTitle___","sectionDescription":"BoTAeZfTtA5f3Vzs__sectionDescription___"};